export default __webpack_public_path__ + "6e30ebb701fafc0c66c83d5c9301a423.png";